<template>
  <section
    id="experience"
    class="section"
    aria-labelledby="work-experience-heading"
  >
    <h2 id="work-experience-heading">Experience</h2>
    <p>
      Studying Computer Science and Engineering at
      <strong>University of Business and Technology (UBT)</strong> has provided
      me with a strong foundation of knowledge in programming languages,
      software engineering, databases, networking, algorithms and technical
      skills, which has prepared me to succeed in this evolving industry.
    </p>
    <p>
      Completing various courses and trainings in the fields of digital skills
      and web development, as well as working on real-world projects, have
      strengthened my skills and knowledge in these areas.
    </p>
    <p>
      I'm currently working as a Frontend Developer at
      <strong>a&o Hostels</strong>, dedicated to enhance the user experience for
      their customers and employees. As a member of the development team, I
      contribute to the development and improvement of various web projects that
      are part of the company and align with its goals and vision
    </p>

    <img class="shapes-image" src="@/assets/img/background/shapes-image.svg" />

    <div class="section-content">
      <div class="timeline-container">
        <div class="work-experience">
          <h3>Work Experience</h3>

          <div v-for="work in workExperience" class="timeline" :key="work">
            <artice
              class="timeline-item wow animate__fadeInDown"
              data-wow-duration="1s"
            >
              <span class="timeline-date-location">
                <b class="date"
                  ><i class="fa fa-calendar-check"></i> {{ work.date }}</b
                >
                <span class="location"
                  ><i class="fa fa-location-dot"></i> {{ work.location }}</span
                >
              </span>
              <h4 class="timeline-title">
                <strong>{{ work.title }}</strong>
              </h4>
              <h5 class="timeline-company">
                <img class="company-icon" :src="work.icon" />
                {{ work.company }}
              </h5>
              <a class="timeline-url" target="_blank" :href="work.href">{{
                work.url
              }}</a>
            </artice>
          </div>
        </div>
        <div class="education-training">
          <h3>Education and Training</h3>

          <div
            v-for="education in educationTraining"
            class="timeline"
            :key="education"
          >
            <artice
              class="timeline-item wow animate__fadeInDown"
              data-wow-duration="1s"
            >
              <span class="timeline-date-location">
                <b class="date"
                  ><i class="fa fa-calendar-check"></i> {{ education.date }}</b
                >
                <span class="location"
                  ><i class="fa fa-location-dot"></i>
                  {{ education.location }}</span
                >
              </span>
              <h4 class="timeline-title">
                <strong>{{ education.title }}</strong>
              </h4>
              <h5 class="timeline-company">
                <img class="company-icon" :src="education.icon" />
                {{ education.company }}
              </h5>
              <div class="timeline-url-container">
                <a
                  class="timeline-url"
                  target="_blank"
                  :href="education.href"
                  >{{ education.url }}</a
                >
                <a
                  v-if="education.certificateUrl"
                  class="timeline-url"
                  target="_blank"
                  :href="education.certificateUrl"
                  >View Certificate</a
                >
              </div>
            </artice>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ExperienceSection",
  data() {
    return {
      workExperience: [
        {
          date: "2022-10-18",
          location: "Berlin, Germany (Remote)",
          title: "Frontend Developer",
          company: "a&o Hostels",
          url: "www.aohostels.com",
          href: "https://www.aohostels.com",
          icon: "https://www.aohostels.com/favicon.ico",
        },
        {
          date: "2020-04-07",
          location: "Ferizaj, Kosovo",
          title: "IT & Web Developer",
          company: "407 ArchStory",
          url: "www.407archstory.com",
          href: "https://407archstory.com",
          icon: "https://407archstory.com/assets/img/favicon.ico",
        },
      ],
      educationTraining: [
        {
          date: "2025-11-25",
          location: "Online",
          title: "Cyber Security Awareness Training",
          company: "SoSafe",
          url: "www.sosafe-awareness.com",
          href: "https://www.sosafe-awareness.com/products/security-awareness-training/",
          icon: "https://sosafe-awareness.com/sosafe-files/uploads/2023/12/cropped-favicon-32x32.png",
          certificateUrl: "/doc/SoSafe_Certificate_Rilind_Tasholli.pdf",
        },
        {
          date: "2025-03-17",
          location: "Online",
          title: "Meta Front-End Developer Professional Certificate",
          company: "Meta",
          url: "www.facebook.com/business",
          href: "https://www.facebook.com/business/learn/front-end-back-end-developer-certificate-coursera",
          icon: "https://static.xx.fbcdn.net/rsrc.php/v4/yg/r/Hn19bEHYJbt.png",
          certificateUrl:
            "https://coursera.org/verify/professional-cert/N2UFPPPZNZFO",
        },
        {
          date: "2022-03-03",
          location: "Kosovo",
          title:
            "ICT & Digital Skills Training on Web Development Professional",
          company: "ICT for Kosovo's Growth",
          url: "www.ictkosovo.eu",
          href: "https://prishtina-rea.net",
          icon: "/images/other/ictkos-fav-icon.png",
          href_OLD: "https://ictkosovo.eu",
          icon_OLD:
            "https://ictkosovo.eu/wp-content/uploads/2020/03/cropped-fav-icon-1-32x32.png",
        },
        {
          date: "2021-10-11",
          location: "Kosovo",
          title:
            "ICT & Digital Skills Training on Web Development Practitioner",
          company: "ICT for Kosovo's Growth",
          url: "www.ictkosovo.eu",
          href: "https://prishtina-rea.net",
          icon: "/images/other/ictkos-fav-icon.png",
          href_OLD: "https://ictkosovo.eu",
          icon_OLD:
            "https://ictkosovo.eu/wp-content/uploads/2020/03/cropped-fav-icon-1-32x32.png",
        },
        {
          date: "2019-10-14",
          location: "Prishtine, Kosovo",
          title: "BSc. Computer Science & Engineering",
          company: "University of Business and Technology (UBT)",
          url: "www.ubt-uni.net",
          href: "https://www.ubt-uni.net",
          icon: "https://www.ubt-uni.net/wp-content/themes/university-of-business-and-technology/repository/logo.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.timeline-container {
  position: relative;
  margin-left: 2vw;
}

.timeline-container h3 {
  margin: 30px 0;
  opacity: 0.85;
  text-align: left;
  text-transform: uppercase;
  font-size: 1.2em;
}

.timeline {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  position: relative;
  background-color: #0abf80;
  width: 3px;
  min-height: 150px;
  display: flex;
  margin-left: 10px;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  position: relative;
  left: 50px;
  text-align: left;
  width: 65vw;
  padding: 25px 0;
  max-width: max-content;
  /* border: dashed 1px red; */
}

.timeline-date-location {
  text-align: left;
  /* white-space: nowrap; */
  opacity: 0.53;
  font-size: 0.93em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px 10px;
}
.timeline-date-location .date {
  font-weight: bold;
  font-size: 1.04em;
  letter-spacing: 0.03em;
}
.timeline-date-location .location {
  white-space: nowrap;
  display: inline-block;
  padding-top: 2px;
}

.timeline-title {
  display: flex;
  align-items: center;
  width: 100%;
  /* white-space: nowrap; */
  position: relative;
  font-size: 1.2em;
  margin: 5px 0;
}

.timeline-title::before {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  border: solid 9px #18191a;
  background-color: #0abf80;
  border-radius: 100px;
  left: -65px;
  box-shadow: 0 0 45px 10px #0abf802b;
  transition: 0.5s;
}
.timeline-item:hover .timeline-title::before {
  box-shadow: 5px 0 85px 22px #0abf8050;
  transition: 0.18s;
  transform: translateY(-3.5px);
}

.timeline-item .timeline-title,
.timeline-item .timeline-company,
.timeline-item .timeline-date-location * {
  transition: 0.3s;
}
.timeline-item:hover .timeline-title {
  color: #9affd4;
}
.timeline-item:hover .timeline-company,
.timeline-item:hover .timeline-date-location * {
  color: #cffae9 !important;
  transition: 0.3s;
}

.timeline-company {
  opacity: 0.8;
  font-weight: normal;
  font-size: 1.1em;
  display: flex;
  align-items: center;
  gap: 6px;
}

.timeline-company .company-icon {
  width: 22px;
  height: 22px;
  border-radius: 2px;
  background-color: #18191a;
}

.timeline-url-container {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.timeline-url,
.timeline-url:visited {
  color: rgb(112, 170, 197);
}

.shapes-image {
  position: absolute;
  top: -150px;
  right: -300px;
  width: 680px;
  opacity: 0.18;
  filter: blur(0.5px);
  /* transform: rotate(-90deg) translateY(-45%); */
  /* z-index: -1; */
}

/*-------------- Tablet/Mobile media queries --------------*/
@media (max-width: 1870px) {
  .shapes-image {
    right: -14vw;
    opacity: 0.12;
    filter: blur(0.6px);
  }
}
@media (max-width: 1440px) {
  .shapes-image {
    opacity: 0.12;
    filter: blur(1.8px);
  }
}
@media (max-width: 1250px) {
  .shapes-image {
    opacity: 0.08;
    filter: blur(1.8px);
    width: 575px;
  }
}

@media (max-width: 800px) {
  .timeline-item {
    left: 30px;
    /* border: dashed 1px red; */
  }

  .timeline-title::before {
    left: -45px;
  }
}

@media (max-width: 500px) {
  .timeline-container {
    margin-left: -5px;
  }
  .timeline-item {
    max-width: unset;
  }
  .timeline-title,
  .timeline-company {
    max-width: 300px;
  }
  .timeline-company {
    font-size: 1.05em;
  }
  .timeline-date-location {
    font-size: 0.9em;
  }
  .shapes-image {
    opacity: 0.08;
    filter: blur(1px);
    width: 435px;
    right: 0;
    top: -200px;
  }
}

@media (max-width: 420px) {
  .timeline-item {
    width: 55vw;
  }
}
</style>
